import { MainPageContent } from "@/routes/_components/main-page";
import t from "@/lang/lang";
import { useSearchParams } from "react-router";
import { useSearchQuery } from "@/services/backend/search/api/service";
import { DocumentResults } from "@/routes/_components/search/document-results";
import { ProcessResults } from "@/routes/_components/search/process-results";
import { CustomerResults } from "@/routes/_components/search/customer-results";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";

// FULL_RESULT_LIMIT is the per-group result cap requested by the full
// results page. It is higher than the header dropdown (backend default 10)
// but stays within the backend's clamp.
const FULL_RESULT_LIMIT = 50;
const MIN_SEARCH_LENGTH = 3;

/**
 * SearchRoute is the full-page counterpart to the header search dropdown.
 * It reads the same `search` URL parameter and requests a higher result
 * limit so the user can see more than the dropdown preview.
 */
export function SearchRoute() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get("search") ?? "";

  const {
    data: results,
    isFetching,
    error,
  } = useSearchQuery(
    { query, limit: FULL_RESULT_LIMIT },
    { skip: query.length < MIN_SEARCH_LENGTH },
  );

  return (
    <MainPageContent className="space-y-6">
      <h4 className="text-xl font-bold">
        {`${t('Suchergebnisse: "') + query}"`}
      </h4>

      <RTKQueryErrorAlert error={error} />

      {query.length < MIN_SEARCH_LENGTH && (
        <p className="text-muted-foreground">
          {t("Bitte mindestens 3 Zeichen eingeben.")}
        </p>
      )}

      {isFetching && <p className="text-muted-foreground">{t("Suche...")}</p>}

      {!isFetching && results && (
        <>
          <DocumentResults documents={results.documents ?? []} expanded />
          <ProcessResults processes={results.processes ?? []} expanded />
          <CustomerResults customers={results.customers ?? []} expanded />
        </>
      )}
    </MainPageContent>
  );
}
